"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[221],{

/***/ 20221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39334);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background-color: var(--blockquote-color);\n  border: 2px solid var(--quaternary-color);\n  box-shadow: 0 0 5px 0 var(--quaternary-color);\n  font-size: 14pt;\n  font-weight: 400;\n  line-height: 1.45;\n  padding: 20px;\n  margin: 30px 0;\n  color: var(--secondary-blue);\n  .keypoint-header {\n    position: absolute;\n    top: -15px;\n    background: var(--primary-color);\n    border-radius: 0px 10px 0px 10px;\n    p {\n      color: var(--white-color);\n      padding: 2px 10px;\n      font-size: 20px;\n    }\n  }\n\n  ul {\n    padding-left: 30px;\n    line-height: 16px;\n    margin: 10px 0 0 0;\n    font-family: 'DBHelvethaicaXBd', sans-serif !important;\n    li {\n      display: flex;\n      align-items: flex-start;\n      font-family: 'Sarabun', sans-serif;\n      ::marker {\n        font-size: 24px;\n        line-height: 0;\n        color: var(--secondary-color);\n      }\n      list-style-type: disc;\n      display: list-item;\n      margin-left: 1.5rem;\n      line-height: 1.45;\n      font-weight: 600;\n      font-size: 20px;\n      margin: 0 0 15px 1.5rem;\n      a {\n        letter-spacing: 0.2px;\n        font-display: swap;\n      }\n    }\n\n    li:last-child {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 767px) {\n      padding: 0px;\n      li {\n        font-size: 20px;\n        line-height: 1.55;\n        /* margin-bottom: 10px; */\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function WidgetKeypoint(param) {
    var isKeyPoint = param.isKeyPoint, article = param.article;
    var _key_point;
    // useEffect(() => {
    //   const keypointContent = document.getElementById('keypoint-content');
    //   while (keypointContent?.firstChild) {
    //     keypointContent?.removeChild(keypointContent?.firstChild);
    //   }
    //   if (isKeyPoint === true && !_.isEmpty(article?.key_point)) {
    //     const element = document.getElementById('feature-image');
    //     element?.scrollIntoView({ behavior: 'smooth', top: 0 });
    //     const div = document.createElement('div');
    //     div.innerHTML = article?.key_point || '';
    //     const strongElements = div.getElementsByTagName('strong');
    //     for (let i = 0; i < strongElements.length; i++) {
    //       strongElements[i].style.fontWeight = 'bold';
    //     }
    //     const speed = NEXT_PUBLIC_SPEED_KEYPOINT ?? 50;
    //     let txt = article?.key_point;
    //     let i = 0;
    //     // let div;
    //     txt = htmlToPlainText(txt?.replace(/<\/?[^>]+(>|$)/g, match => (match === '<li>' ? '_' : '')));
    //     const ul = document.createElement('ul');
    //     let li = document.createElement('div');
    //     const intervalId = setInterval(() => {
    //       if (i < txt.length) {
    //         const char = txt.charAt(i);
    //         if (char === '_') {
    //           keypointContent?.appendChild(ul);
    //           li = document.createElement('li');
    //           // Create a new li element for the next line
    //           keypointContent?.appendChild(li);
    //           ul.appendChild(li);
    //           i++;
    //         } else {
    //           li.innerHTML += char;
    //           i++;
    //         }
    //       }
    //       // else {
    //       //     clearInterval(intervalId);
    //       // }
    //     }, speed);
    //     return () => clearInterval(intervalId);
    //   }
    // }, [isKeyPoint]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionWrapper, {
        className: "keypoint-flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            id: "key-point",
            className: "keypoint-wrapper ".concat(isKeyPoint ? "dis" : "hid"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    className: "hide-seo",
                    dangerouslySetInnerHTML: {
                        __html: "".concat((article === null || article === void 0 ? void 0 : article.blurb) || "")
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "keypoint-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: "KEY POINTS"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    id: "keypoint-content",
                    className: "keypoint-lists",
                    dangerouslySetInnerHTML: {
                        __html: (_key_point = article.key_point) !== null && _key_point !== void 0 ? _key_point : ""
                    }
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetKeypoint);
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject());


/***/ })

}]);